import React from 'react';
import Head from 'next/head';
import Image from 'next/image';
import { Button, Col, Container, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import { FaCircleCheck } from 'react-icons/fa6';
import { generator, http, layout, format } from '@/helpers/index';
import { constant } from '@/helpers/constant';
import Divider from '@/components/divider';
import QuickInquiry from '@/components/quick-inquiry';
import LandpageFooter from '@/components/landpage-footer';
import Seo from '@/components/seo';
import { auth } from '@/services/auth';

function LandPage({ warning, product }) {
  const css = (`
  body {
    background-image: url('/assets/images/land-bg.png') !important;
    background-color: #000717 !important;
  }`);

  const handleBuyNow = () => {
    window.location.href = '/campanhas/nao-compre-carro-sem-antes-consultar-o-historico#quick-inquiry';
    layout.focus('name', 500);
  };

  const buyNow = () => (
    <div className="d-grid gap-2">
      <Button variant="success" size="lg" onClick={handleBuyNow}>
        Comprar Agora
      </Button>
    </div>
  );

  const discount = () => (
    <Col xs={12} className="text-center">
      <Container className="mt-0 mb-0">
        <div className="price-from land-h2 text-yellow mt-1">
          <span>De: </span>
          <s className="fw-bold">{format.currency(product.commercialValue)}</s>
        </div>
        <div className="price-to land-h1 text-green mt-1">
          <span>Por: </span>
          <span className="fw-bold">{format.currency(product.value)}</span>
        </div>
        {buyNow()}
      </Container>
    </Col>
  );

  return (
    <>
      <Seo
        title="Não Compre Carro sem Antes Consultar o Histórico! | AboutCar"
        description="Evite cair em ciladas ao comprar um veículo usado. Puxe o histórico completo por placa: leilão, sinistro, débitos, financiamentos e restrições."
        keywords="nao compre carro sem consultar, consulta placa leilao, laudo veicular usado, historico carro placa"
      />
      <Head>
        <style type="text/css">{css}</style>
      </Head>
      <Row className="m-0">
        <Col sm={6} xs={12} className="text-end land-car">
          <Image src="/assets/images/compass.png" width="890" height="540" border="0" alt="Jeep Compass azul escuro" className="img-fluid" />
        </Col>
        <Col sm={6} xs={12} className="text-start">
          <h1 className="land-h1 featurette-heading">Não compre carro, sem antes consultar o Histórico!</h1>
          <h2 className="land-h2">É Rápido, Fácil e Totalmente Seguro!</h2>
        </Col>
        <Divider color="default" className="mt-5 mb-5" />
        {discount()}
        <Divider color="default" className="mt-5 mb-5" />
        <Col xs={12} className="text-white lead text-center">
          <Container className="mt-0 mb-0">
            <Row>
              <Col sm={5} xs={12} className="text-center d-block d-sm-none mb-3">
                <img src="/assets/images/land-million.svg" border="0" alt="Sucesso" loading="lazy" height={315} className="img-fluid mt-3" />
              </Col>
              <Col sm={7} xs={12} className="text-end">
                <h2 className="land-h2 featurette-heading mt-0">Mais de 1 milhão de pessoas</h2>
                <strong>+</strong>
                <span> de </span>
                <strong>1 milhão</strong>
                <span> pessoas já evitaram sérios prejuízos na comercialização de veículos!</span>
                <div>
                  Utilizando nossa plataforma de forma rápida e segura, você precisará informar apenas a placa e recuperaremos todo o histórico do veículo em alguns instantes.
                </div>
                {buyNow()}
              </Col>
              <Col sm={5} xs={12} className="text-center d-none d-sm-block">
                <img src="/assets/images/land-million.svg" border="0" alt="Sucesso" loading="lazy" height={315} className="img-fluid mt-3" />
              </Col>
            </Row>
          </Container>
        </Col>
        <Divider color="default" className="mt-5 mb-5" />
        <Col xs={12} className="text-white text-center">
          <Container className="mt-0 mb-0">
            <Row>
              <Col sm={3} xs={12} className="text-center mb-3">
                <img src="/assets/images/land-why.svg" border="0" alt="Sucesso" loading="lazy" height={490} className="img-fluid" />
              </Col>
              <Col sm={9} xs={12} className="text-start">
                <h2 className="land-h2 featurette-heading mt-0">Por que devo consultar o veículo?</h2>
                <div className="lead">Se você está se perguntando isso, só existem duas opções:</div>
                <div className="lead fw-bold">1 - Você sempre comprou  veículos na sorte.</div>
                <div className="lead fw-bold">2 - Você ainda não conhecia a AboutCar!</div>
                <div className="lead">
                  Nossa plataforma foi criada por profissionais que conhecem o mercado automotivo e todos seus pontos obscuros. Por isso, conseguimos compilar centenas de dados em um único relatório. Tudo isso de forma simples, para que você mesmo possa entender sem precisar de um especialista.
                </div>
                <h3>Não caia em golpes, evite prejuízos!</h3>
                {buyNow()}
              </Col>
            </Row>
          </Container>
        </Col>
        <Divider color="default" className="mt-5 mb-5" />
        <Col xs={12} className="text-center"><h2 className="land-h2 featurette-heading mt-0">Principais informações do Relatório</h2></Col>
        <Col xs={12} className="text-white text-center">
          <Container className="mt-0 mb-0">
            <Row>
              <Col sm={3} xs={12} className="mb-3">
                <div className="text-center mb-2">
                  <img src="/assets/images/car-auction.svg" border="0" alt="Leilão" loading="lazy" height={100} />
                </div>
                <h3>Leilão</h3>
                <div className="lead">Consultamos em tempo real todas as fontes oficiais de registros e passagens por leilão.</div>
              </Col>
              <Col sm={3} xs={12} className="mb-3">
                <div className="text-center mb-2">
                  <img src="/assets/images/car-debts.svg" border="0" alt="Débitos e Restrições" loading="lazy" height={100} />
                </div>
                <h3>Débitos e Restrições</h3>
                <div className="lead">Checamos em todos os órgãos para trazer todos os registros de débito e restrição.</div>
              </Col>
              <Col sm={3} xs={12} className="mb-3">
                <div className="text-center mb-2">
                  <img src="/assets/images/car-legal.svg" border="0" alt="RENAJUD" loading="lazy" height={100} />
                </div>
                <h3>RENAJUD</h3>
                <div className="lead">Comprar um veículo com Restrição Judicial vai te trazer dor de cabeça e grande prejuízo.</div>
              </Col>
              <Col sm={3} xs={12} className="mb-3">
                <div className="text-center mb-2">
                  <img src="/assets/images/car-casualty.svg" border="0" alt="Indício de Sinistro" loading="lazy" height={100} />
                </div>
                <h3>Indício de Sinistro</h3>
                <div className="lead">Consultamos em 3 fontes diferentes para saber se o veículo possuí algum indício de sinistro.</div>
              </Col>
              <Col sm={3} xs={12} className="mb-3">
                <div className="text-center mb-2">
                  <img src="/assets/images/car-owners.svg" border="0" alt="Quantidade de Proprietário" loading="lazy" height={100} />
                </div>
                <h3>Quantidade de Proprietário</h3>
                <div className="lead">Informamos a quantidade de proprietários que o veículo já teve.</div>
              </Col>
              <Col sm={3} xs={12} className="mb-3">
                <div className="text-center mb-2">
                  <img src="/assets/images/car-robbery.svg" border="0" alt="Roubo e Furto" loading="lazy" height={100} />
                </div>
                <h3>Roubo e Furto</h3>
                <div className="lead">Um veículo que já foi fruto de roubo e furto, pode te trazer problemas, saiba tudo antes de fechar o negócio.</div>
              </Col>
              <Col sm={3} xs={12} className="mb-3">
                <div className="text-center mb-2">
                  <img src="/assets/images/car-engine.svg" border="0" alt="Motor alterado" loading="lazy" height={100} />
                </div>
                <h3>Motor alterado</h3>
                <div className="lead">Um veículo com motor alterado pode te dar prejuízo e muita dor de cabeça.</div>
              </Col>
              <Col sm={3} xs={12} className="mb-3">
                <div className="text-center mb-2">
                  <img src="/assets/images/car-lien2.svg" border="0" alt="Detalhe de Gravame" loading="lazy" height={100} />
                </div>
                <h3>Detalhe de Gravame</h3>
                <div className="lead">Uma simples consulta no DETRAN não te garante segurança. Tenha o histórico de gravame do veículo!</div>
              </Col>
            </Row>
            {buyNow()}
          </Container>
        </Col>
        <Divider color="default" className="mt-5 mb-5" />
        <Col xs={12} className="text-center"><h2 className="land-h2 featurette-heading mt-0">Informações disponíveis sobre qualquer veículo</h2></Col>
        <Col xs={12}>
          <Container className="mt-0 mb-0">
            <Row className="detail-items">
              {constant.inquiry.items.vehicle.map((value) => (
                <Col xs={12} sm={3} key={generator.token()} className="text-start font-items">
                  <OverlayTrigger
                    overlay={(
                      <Popover>
                        <Popover.Header style={{ backgroundColor: '#0BC5BD' }}>{value}</Popover.Header>
                        <Popover.Body>
                          <div className="" dangerouslySetInnerHTML={{ __html: constant.inquiry.details.all[value] }} />
                        </Popover.Body>
                      </Popover>
                    )}
                  >
                    <Button
                      variant="link"
                      size="sm"
                      className="info-detail text-start"
                    >
                      <FaCircleCheck className="me-1" />
                      {value}
                    </Button>
                  </OverlayTrigger>
                </Col>
              ))}
            </Row>
          </Container>
        </Col>
        <Divider color="default" className="mt-5 mb-5" />
        <Col xs={12} className="text-center"><h2 className="land-h2 featurette-heading mt-0">Veja como é Simples</h2></Col>
        <Col xs={12} className="text-white text-center">
          <Container className="mt-0 mb-0">
            <Row>
              <Col sm={4} xs={12} className="mb-3">
                <div className="text-center mb-2">
                  <img src="/assets/images/use-pass-1.svg" border="0" alt="Leilão" loading="lazy" height={100} />
                </div>
                <h3>Passo 1</h3>
                <div className="lead fw-bold">Clique em Comprar Agora</div>
                <div className="lead">Preencha seu Nome, Email, Telefone Celular e a Placa do Veículo.</div>
              </Col>
              <Col sm={4} xs={12} className="mb-3">
                <div className="text-center mb-2">
                  <img src="/assets/images/use-pass-2.svg" border="0" alt="Débitos e Restrições" loading="lazy" height={100} />
                </div>
                <h3>Passo 2</h3>
                <div className="lead fw-bold">Selecione a Forma de Pagamento</div>
                <div className="lead">
                  <span>Escolha como deseja pagar (PIX ou Cartão de Crédito) e clique em </span>
                  <strong>Efetuar Pagamento e Consultar</strong>
                  <span>.</span>
                </div>
              </Col>
              <Col sm={4} xs={12} className="mb-3">
                <div className="text-center mb-2">
                  <img src="/assets/images/use-pass-3.svg" border="0" alt="RENAJUD" loading="lazy" height={100} />
                </div>
                <h3>Passo 3</h3>
                <div className="lead fw-bold">Visualize seu Relatório</div>
                <div className="lead">Em poucos instantes você visualizará o relatório completo contendo todas as informações importantes do veículo.</div>
              </Col>
            </Row>
            {buyNow()}
          </Container>
        </Col>
        <Divider color="default" className="mt-5 mb-5" />
        <Col xs={12} className="text-center"><h2 className="land-h2 featurette-heading mt-0">Veja um exemplo de Consulta</h2></Col>
        <Col xs={12}>
          <Container className="mt-0 mb-0">
            <video width="100%" loop autoPlay="autoplay" controls muted className="rounded">
              <source src="/assets/videos/report-sample.mp4" type="video/mp4" />
            </video>
          </Container>
        </Col>
        <Divider color="default" className="mt-5 mb-5" />
        <Col xs={12} className="text-center"><h2 className="land-h2 featurette-heading mt-0">Rápido, Fácil e Totalmente Seguro!</h2></Col>
        {discount()}
        <Col xs={12}>
          <Container className="bg-white rounded p-1">
            <QuickInquiry options={{
              warning, product, ignoreTitle: true, size: 'lg', tag: 'NAO-COMPRE-CARRO'
            }}
            />
          </Container>
        </Col>
        <LandpageFooter />
      </Row>
    </>
  );
}

LandPage.code = '';
LandPage.layout = 'landpage';
export default LandPage;

export async function getServerSideProps(context) {
  const res = await http.baseAsync('GET', '/configurations');
  let warning = '';
  if (res.ok) {
    const item = await res.json();
    if (item && !item.vendors.checktudo.online) {
      warning = item.vendors.message;
    }
  }

  const resProduct = await http.baseAsync('GET', '/products/veiculo-total-mais', null, false, auth.headers());
  if (!resProduct.ok) {
    return {
      props: {},
    };
  }
  const product = await resProduct.json();

  return {
    props: {
      warning,
      product,
    },
  };
}
